const UAEvents = function () {

    function _click(that, theOriginLevel2, theActionCause, tilePositionSelector, parentSelector, catalog) {
        let $thisTile;
        let documentTitle;
        let documentPosition;
        let documentUri;
        let documentUriHash;
        let sourceName;
        let contentIDValue;
        let brand;
        let price;
        let name;
        let category;
        let genericId;
        let rankingModifier;
        let queryPipeline;
        let searchQueryUid;
        let originLevel1;

        const contentIDKey = 'permanentid';
        const language = $('html').attr('lang');
        const userAgent = navigator.userAgent;
        let originContext = 'Search';
        const originLevel2 = theOriginLevel2;
        const actionCause = theActionCause;

        if (theOriginLevel2 === 'product') {
            $thisTile = $(that).parents(parentSelector);
            documentTitle = $thisTile.find('.head__title').text();
            contentIDValue = $(that).parents(parentSelector).attr('data-product-code');
            brand = $thisTile.attr('data-product-brand');
            price = $thisTile.find('[data-main-price]').attr('data-main-price');
            name = $thisTile.attr('data-product-name');
            category = $thisTile.attr('data-ec-category');
            genericId = $thisTile.attr('data-generic-id');

            let tileIndex = $thisTile.attr('data-index');
            if (typeof tileIndex !== 'undefined') {
                documentPosition = tileIndex;
            } else {
                documentPosition = _tilePosition($thisTile, tilePositionSelector, '.product-page-nav-standard .ppn--pagination .current', 30, catalog);
            }

            let context =  $thisTile.attr('data-origin-context');
            if (typeof context !== 'undefined') {
                originContext = context;
            }

        } else if (theOriginLevel2 === 'article') {
            $thisTile = $(that);
            documentTitle = $thisTile.attr('data-title');
            documentPosition = _tilePosition($thisTile, tilePositionSelector, '.flex-parent .ppn--pagination .current', 10, catalog);
        } else {
            return false;
        }

        queryPipeline = $thisTile.attr('data-query-pipeline');
        searchQueryUid = $thisTile.attr('data-search-query-uid');
        rankingModifier = $thisTile.attr('data-ranking-modifier');
        originLevel1 = $thisTile.attr('data-origin-level1');
        documentUri = $thisTile.attr('data-uri');
        documentUriHash = $thisTile.attr('data-uri-hash');
        sourceName = $thisTile.attr('data-source-name');

        if (sourceName === undefined) {
            return false;
        }

        let clickEventData = {
            language: language,
            userAgent: userAgent,
            documentPosition: documentPosition,
            documentTitle: documentTitle,
            documentUri: documentUri,
            documentUriHash: documentUriHash,
            sourceName: sourceName,
            queryPipeline: queryPipeline,
            originContext: originContext,
            originLevel2: originLevel2,
            actionCause: actionCause,
            searchQueryUid: searchQueryUid,
            rankingModifier: rankingModifier,
            originLevel1: originLevel1,
            customData: {
                contentIDKey: contentIDKey,
                contentIDValue: contentIDValue,
                brand: brand,
                price: price,
                name: name,
                category: category,
                group: genericId,
                variant: genericId
            }
        }
        $.ajax({
            url: analyticsClickEventUrl,
            type: 'POST',
            contentType: 'application/json',
            dataType: 'html',
            data: JSON.stringify(clickEventData),
            cache: false
        });
    }

    function _defineDocument(tilePositionSelector, catalog) {
        $(tilePositionSelector + ' .product-details-link, ' + tilePositionSelector + ' .pt__visual a').on('click contextmenu', function () {
            UAEvents.click(this, 'product', 'documentOpen', tilePositionSelector, '.tile-product', catalog);
        });
        $(tilePositionSelector + ' .pt__content--actions .action__favorite').click(function () {
            UAEvents.click(this, 'product', 'documentOpen', tilePositionSelector, '.tile-product', catalog);
        });
        $(tilePositionSelector + ' .pt__content--actions .cart-plus').click(function () {
            UAEvents.click(this, 'product', 'documentOpen', tilePositionSelector, '.tile-product', catalog);
        });
        $(tilePositionSelector + ' .pt__content--actions .plus-addToCart').click(function () {
            UAEvents.click(this, 'product', 'documentOpen', tilePositionSelector, '.tile-product', catalog);
        });
        $(tilePositionSelector + ' .pt__content--actions .minus-addToCart').click(function () {
            UAEvents.click(this, 'product', 'documentOpen', tilePositionSelector, '.tile-product', catalog);
        });
    }

    function _defineDocumentClick(selParent, sel, origin, catalog) {
        $(selParent + sel).click(function () {
            UAEvents.click(this, origin, 'documentOpen', selParent, catalog);
        });
    }

    function _tilePosition(tile, selParent, sel, numberOfTile, catalog) {
        let $tiles = $(selParent);
        let position;
        if ($tiles.length) {
            let pageNumber = $(sel).text();
            if (catalog) {
                let positionInPage = $.inArray(tile[0], $tiles) + 1;
                position = positionInPage + ((pageNumber - 1) * (numberOfTile));
            } else {
                position = $.inArray(tile[0], $tiles) + 1;
            }
        }
        return position;
    }

    return {
        click: _click,
        defineDocument: _defineDocument,
        defineDocumentClick: _defineDocumentClick
    };
}();